export enum InboxFolderType {
  INBOX = 'inbox',
  FOLDER = 'folder',
  DELETED_FOLDER = 'deletedFolder',
}
export interface InboxFolderModel {
  type: InboxFolderType;
  id: number;
}
